import ForgetPasswordSent from '@modules/account/components/forget-password-sent';

export default function ForgetPasswordSentPage() {
  return <ForgetPasswordSent />;
}
